// import 'jquery-ui/themes/base/base.css';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/button.css';
import 'jquery-ui/themes/base/dialog.css';
import 'jquery-ui/themes/base/resizable.css';
import 'jquery-ui/themes/base/tabs.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-contextmenu/dist/jquery.contextMenu.min.css';

// import 'jquery-ui/themes/base/menu.css';
// import 'jquery-ui/themes/base/autocomplete.css';
import $ from 'jquery';
window.$ = $;
// import autocomplete from 'jquery-ui/ui/widgets/autocomplete';
// import widget      from 'jquery-ui/ui/widget.js';
import dialog      from 'jquery-ui/ui/widgets/dialog';
import tabs        from 'jquery-ui/ui/widgets/tabs';
import contextmenu from 'jquery-contextmenu';
